module.exports = __webpack_public_path__ + "static/media/home_bg.9a6917b3.jpg";